<div class="preview-dialog-container">
  <div class="header">
    <div class="title">{{ title | translate }}</div>
  </div>
  <div class="content">
    <app-rich-text-editor
    [readonly]="true"
    [editableInline]="false"
    [value]="content"
  >
  </app-rich-text-editor>
  </div>
  <div class="footer">
    <div class="actions">
      <button class="confirmation-button" (click)="close()">{{ 'buttons.close' | translate }}</button>
    </div>
  </div>
</div>
